/** One look for every switch on «مدیریت اعلان‌ها». */
export const switchProps = {
    onColor: '#75B844',
    offColor: '#B6BCC8',
    onHandleColor: '#EAEEF0',
    handleDiameter: 25,
    uncheckedIcon: false as const,
    checkedIcon: false as const,
    boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.6)',
    activeBoxShadow: '0px 1px 5px rgba(0, 0, 0, 0.6)',
    height: 30,
    width: 60,
}
